const Point = function() {
    var E = 0, N = 0;
    var X = 0, Y = 0;

    Object.defineProperty(this, "E", {set: (newE) => {E = newE;},get: () => E});
    Object.defineProperty(this, "N", {set: (newN) => {N = newN;},get: () => N});
    Object.defineProperty(this, "X", {set: (newX) => {X = newX;},get: () => X});
    Object.defineProperty(this, "Y", {set: (newY) => {Y = newY;},get: () => Y});

    Object.defineProperty(this, "NE", {set: ([newN, newE]) => {N = newN;E = newE;},get: () => [N, E]});
    Object.defineProperty(this, "EN", {set: ([newE, newN]) => {N = newN;E = newE;},get: () => [E, N]});
    Object.defineProperty(this, "XY", {set: ([newX, newY]) => {X = newX;Y = newY;},get: () => [X, Y]});
    Object.defineProperty(this, "YX", {set: ([newY, newX]) => {X = newX;Y = newY;},get: () => [Y, X]});

    // set point definition
    this.set = (PD) => {
        if (PD.X !== undefined && PD.Y !== undefined) {
            this.XY = [PD.X, PD.Y];
        }
        if (PD.N !== undefined && PD.E !== undefined) {
            this.EN = [PD.E, PD.N];
        }
    };
};

export default Point;
